import AsyncImportList from './src/main';

/* istanbul ignore next */
AsyncImportList.install = function(Vue) {
  Vue.component(AsyncImportList.name, AsyncImportList);
};

export default AsyncImportList;

